import { Layout } from '../components/Layout/Layout'
import { ProjectList } from '../components/Projects/ProjectList'

export const Projects = () => {
  return (
    <Layout>
      <ProjectList />
    </Layout>
  )
}
